module.exports = __webpack_public_path__ + "img/sad-full.e6889adf.svg";